import { render, staticRenderFns } from "./search.vue?vue&type=template&id=c9d5afd8&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9d5afd8')) {
      api.createRecord('c9d5afd8', component.options)
    } else {
      api.reload('c9d5afd8', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=c9d5afd8&", function () {
      api.rerender('c9d5afd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/categories/partials/search.vue"
export default component.exports